import React from 'react';
import PropTypes from "prop-types";

import { withCacheRead, withCacheAdd } from './cache-container';

const SCHEMA_CACHABLE_FIELDS = {
    'product':[
        'sku',
        'itemId',
        'prodId',
        'images[0]',
        'name',
        'offers',
        'rating',
        'slug',
        'prdClass',
        'defaultImages'
     ],
    'page': ['vanityUrl']
}

/*
  Wrapper method for caching certain schema types in redux store
 */
const PartialDataAdd = withCacheAdd(class extends React.Component{
    static propTypes = {
        cacheKey: PropTypes.string.isRequired,
        schema: PropTypes.oneOf(['product', 'page']).isRequired,
        cacheValue: PropTypes.object.isRequired,
        cacheEvent: PropTypes.oneOf(['onload', 'onclick']),
    };

    static defaultProps = {
        cacheEvent: "onclick"
    }

    componentDidMount(){
         const { cacheKey,  cacheValue, cacheEvent } = this.props;
         if(cacheEvent === 'onload'){
                 this.props.cacheAdd(cacheKey, this.getCacheObject(cacheValue));
         }
    }

    componentDidUpdate(prevProps){
        const { cacheKey,  cacheValue, cacheEvent } = this.props;
        if(cacheKey !== prevProps.cacheKey && cacheEvent === 'onload'){
            this.props.cacheAdd(cacheKey, this.getCacheObject(cacheValue));
        }
    }

    clickHandler = () => {
        const { cacheKey,  cacheValue } = this.props;
        this.props.cacheAdd(cacheKey, this.getCacheObject(cacheValue));
    }

    /*
        Returns the cachable object based on the specified schema. 
        Partial add limits what fields can be cached. 
        This is to prevent caching user defined data about a product for example
        that doesn't apply to elsewhere on the stie
     */
    getCacheObject = (cacheValue) => {
        const { schema } = this.props;
        let arrayRegex = /\[([0-9]+)\]$/;
        try{
            return SCHEMA_CACHABLE_FIELDS[schema].reduce((rObj, field) => {
                const arrayIndex = field.match(arrayRegex);
                let fieldName = field.replace(arrayRegex,"");
                if(arrayIndex && Array.isArray(cacheValue[fieldName])){
                    let arraySlice = (arrayIndex[1] * 1) + 1;
                    let fieldName = field.replace(arrayRegex,"");
                    rObj[fieldName] = cacheValue[fieldName].slice(0,arraySlice);
                }else{
                    rObj[field] = cacheValue[field]
                }
                return rObj;
            },{});
        }catch(e){
            return null
        }
    }

    render(){
        const { cacheEvent, children, key, className } = this.props;
        if(cacheEvent === 'onclick'){
            return <span className={'cache-add-container' + `${className ? ' ' + className : ''}`} onClick={this.clickHandler} key={key}>{children}</span>
        }else if(className){
            return <div className={'cache-add-container ' + className}  key={key}>{children}</div>;
        }
        return children;
    }

});

/*
    Wrapper method for reading data cached in redux
 */
const PartialDataRead = withCacheRead(class extends React.Component{
    static propTypes = {
        cacheKey: PropTypes.string
    };

    render(){
        let { cacheValue } = this.props;
        if(cacheValue){
            cacheValue.fromReduxCache = true;
        }
        return this.props.children(cacheValue);
    }
});


export { 
    PartialDataAdd,
    PartialDataRead
};